/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const postContent = (
	<SVG xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M4 20h16v-1.5H4V20zm0-4.8h16v-1.5H4v1.5zm0-6.4v1.5h16V8.8H4zM16 4H4v1.5h12V4z" />
	</SVG>
);

export default postContent;
